<template>
  <v-btn v-if="allowed" type="button" color="primary" variant="text" min-height="48"
    :disabled="disabled" :aria-label="label" @click="open = true">
    <v-icon start>add</v-icon>{{ kind === 'company' ? 'Agregar empresa' : 'Agregar lugar' }}
  </v-btn>
  <component :is="editor" v-if="active && open && allowed" v-model="open"
    v-bind="kind === 'location' ? { presetType: locationType } : {}"
    @saved="$emit('saved', $event)" />
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import CompanyEditor from '../Company/AddEditCompanyForm.vue'
import LocationEditor from '../Location/AddEditLocationForm.vue'

const props = defineProps({
  kind: { type: String, required: true },
  label: { type: String, required: true },
  locationType: { type: String, default: '' },
  active: { type: Boolean, default: true },
  disabled: Boolean
})
defineEmits(['saved'])
const store = useStore()
const open = ref(false)
watch(() => props.active, active => { if (!active) open.value = false })
const allowed = computed(() => store.getters['authModule/hasPermission'](`catalog.${props.kind === 'company' ? 'companies' : 'locations'}.create`))
const editor = computed(() => props.kind === 'company' ? CompanyEditor : LocationEditor)
</script>
